import React, { useEffect, useState } from 'react';
import { Checkbox, ICheckboxStyles } from '@fluentui/react';

const checkboxStyles : ICheckboxStyles = {
    root: {
        selectors: {
            ':hover .ms-Checkbox-label .ms-Checkbox-checkbox': {
                backgroundColor: 'var(--color-primario)',
                borderColor: 'var(--color-primario)',
                color: '#ffffff',
            },
            ':hover .ms-Checkbox-label .ms-Checkbox-checkmark': {
                backgroundColor: 'var(--color-primario)',
                borderColor: 'var(--color-primario)',
                color: '#ffffff',
            },
        }
    },
    label: {
        marginLeft: 5,
    },
    checkbox: {
        backgroundColor: '#ffffff',
        borderColor: 'var(--color-primario)',
        color: '#ffffff',
    },
    checkmark: {
        backgroundColor: 'var(--color-primario)',
        borderColor: 'var(--color-primario)',
        color: '#ffffff',
    },
};

interface ICheckboxComponentProps {
    checked: boolean;
    onChange: (value: boolean) => void;
    label: string;
};

const CheckboxComponent = (props: ICheckboxComponentProps) => {
    const [checked, setChecked] = useState<boolean>(props.checked);

    useEffect(() => {
        setChecked(props.checked);
    }, [props.checked]);

    const onChange = (event?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) : void => {
        setChecked(checked ? checked : false);
        props.onChange(checked ? checked : false);
    };

    return (
        <Checkbox 
            styles={checkboxStyles}
            label={props.label}
            checked={checked} 
            onChange={onChange} />
    );
};

export default CheckboxComponent;
